import {useSelector} from "react-redux";
import {selectPortfoliosWithSignals, selectStarredPortfolios} from "../../Store/slices/portfolios.slice";
import {selectUserFields} from "../../Store/slices/user.slice";
import {Col, Layout, Row, Card, Space, Divider, Typography} from "antd";
import HomeHeader from "../HomeHeader";
import React from "react";
import DashboardCards from "./DashboardCards";
import TickerEvents from "../../SuperComponents/TickerEvents/TickerEvents";
import Widget from "../../Components/Widget";
import PortfolioList from "../../Pages/Portfolio/PortfolioList";
import WidgetContainer from "../../Components/WidgetContainer";
const { Content } = Layout;





const IAPlatformAppHome = ({ widgets }) => {
    const portfolios = useSelector(selectPortfoliosWithSignals);
    const settings = useSelector((state) => selectUserFields(state, 'settings'));
    const starredPortfolios = useSelector(selectStarredPortfolios);
    const companyDetails = useSelector((state) => selectUserFields(state, 'company_details'));

    return (
        <Layout className={'app-home'} style={{ height: '100%', display: 'flex', flexDirection: 'column', overflowX: 'hidden'}}>
            <Content style={{
                height: 'auto',
                padding: '50px'
            }}>
                <Row className={'px-3'} justify={'center'} gutter={[96, 32]} align={'top'} wrap={true}>
                    <Col flex={'0 0 600px'}>
                        <HomeHeader
                            username={settings?.display_name??""}
                            company={companyDetails}
                        />
                        <Divider/>
                        <WidgetContainer widgets={widgets} />
                        <Divider orientation={'left'}/>
                        <PortfolioList portfolios={starredPortfolios}  />
                    </Col>
                    <Col flex={'0 0 700px'} offset={1}>
                        <DashboardCards portfolios={portfolios} />
                        <Divider/>
                        <Card bordered={false}>
                            <TickerEvents/>
                        </Card>
                    </Col>
                </Row>
              <Divider/>
            </Content>
        </Layout>
    );
};

export default IAPlatformAppHome;